// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="py-6 text-center text-white bg-red-600">
      <p>&copy; 2025 EvoWishes. Всички права запазени.</p>
      <div className="mt-4 flex justify-center space-x-4 text-sm">
        <Link to="/terms" className="text-white hover:underline">Условия</Link>
        <Link to="/privacy" className="text-white hover:underline">Поверителност</Link>
        <Link to="/contact" className="text-white hover:underline">Контакт</Link>
      </div>
    </footer>
  );
};

export default Footer;